<script lang="ts" setup>
import { Keyboard } from '@capacitor/keyboard';
interface Props {
  modelValue: number,
  unit?: string,
  allowNegative: boolean,
}

const props = defineProps<Props>();
const emit = defineEmits<{
  'update:modelValue': [newValue: number]
}>();
const { n } = useEkI18n();

const platformStore = usePlatformStore();

const count = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    const filteredValue = value
      .toString()
      .replace(/[^0-9.,-]+/g, '')
      .replace(',', '.');

    let newValue = Math.round((Number(filteredValue) + Number.EPSILON) * 100) / 100;

    if (!props.allowNegative) {
      newValue = Math.max(0, newValue);
    }

    emit('update:modelValue', newValue);
  }
});

onMounted(() => {
  if (platformStore.isIos) {
    Keyboard.setAccessoryBarVisible({ isVisible: true });
  }
});

function decrement() {
  if (props.allowNegative || count.value > 0) {
    count.value -= 1;
  }
}

</script>

<template>
  <div class="stepper-container">
    <IonButton
      color="dark"
      fill="outline"
      class="operator"
      @click="decrement()"
    >
      <FontAwesomeIcon
        class="large-icon"
        :icon="['fal', 'minus']"
      />
    </IonButton>
    <div class="quantity-container">
      <IonLabel aria-label="Unit amount">
        {{ n(count, 'decimal') }}
      </IonLabel>
      <span v-if="props.unit">{{ props.unit }}</span>
    </div>
    <IonButton
      color="dark"
      fill="outline"
      class="operator"
      @click="count++"
    >
      <FontAwesomeIcon
        class="large-icon"
        :icon="['fal', 'plus']"
      />
    </IonButton>
  </div>
</template>

<style scoped>
.stepper-container {
  display: grid;
  grid-template-columns: auto auto auto;
  justify-items: center;
  gap: 8px;
  text-align: center;
}
.quantity-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  max-width: 50px;
  padding: 0 10px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.input-no-styling {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: textfield;
  width: auto;
  margin: 0;
  padding: 0;
  border: none;
  background-color: transparent;
  width: 100%;
  text-align: center;
}

.operator{
  width: 36px;
  height: 36px;
  --border-radius: 50%;
}

.operator::part(native) {
  padding: 0px;
}

.large-icon {
  font-size: large;
  color: var('--ion-color-tertiary-contrast');
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0;
}
</style>
